import React from 'react';
import PropTypes from 'prop-types';

import { round5 } from 'utilities/math';

const SummaryComponent = props =>
  <div className="font-14 flex space-between">
    <span className="inline-block pr-30">
      <span className="opacity-50">
        {props.slopeLabel}
      </span>

      <br />

      <span className="sample-mean">
        {round5(props.slope)}
      </span>
    </span>

    <span className="inline-block pr-30">
      <span className="opacity-50">
        {props.interceptLabel}
      </span>

      <br />

      <span className="sample-stdev">
        {round5(props.intercept)}
      </span>
    </span>

    <span className="inline-block pr-30">
      <span className="opacity-50">
        {props.correlationLabel}
      </span>

      <br />

      <span className="number-of-samples">
        {typeof props.correlation === 'number' ? round5(props.correlation) : props.correlation}
      </span>
    </span>

    <span className="inline-block pr-30">
      <span className="opacity-50">
        {props.numberOfSamplesLabel}
      </span>

      <br />

      <span className="number-of-samples">
        {round5(props.numberOfSamples)}
      </span>
    </span>
  </div>;

SummaryComponent.propTypes = {
  slope: PropTypes.number.isRequired,
  slopeLabel: PropTypes.string.isRequired,

  intercept: PropTypes.number.isRequired,
  interceptLabel: PropTypes.string.isRequired,

  correlation: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  correlationLabel: PropTypes.string.isRequired,

  numberOfSamples: PropTypes.number.isRequired,
  numberOfSamplesLabel: PropTypes.string.isRequired
};

export default SummaryComponent;
